import React from 'react';
import PropTypes from 'prop-types';
import ContentWrapper from '../components/ContentWrapper/ContentWrapper';
import HeadingForm from '../layout/HeadingForm';
import withDynamicButtonCaption from './withDynamicButtonCaption';

const withSingleFieldValidation = (WrappedComponent) => {
  class WithSingleFieldValidation extends React.Component {
    constructor(props) {
      super(props);

      this.getValidationProps = this.getValidationProps.bind(this);
    }

    getValidationProps() {
      const {
        name,
        values,
        onChange,
        errors,
      } = this.props;
      return {
        key: name,
        name,
        value: values && values[name],
        error: errors && errors[name],
        onChange,
      };
    }

    render() {
      const {
        isValid,
        localePath,
        onClick,
        buttonText,
        displayMultipleSelectInformation,
      } = this.props;

      const { t } = this.context;

      return (
        <ContentWrapper
          isButtonDisabled={!isValid}
          onClick={onClick}
          title={buttonText}
        >
          <HeadingForm
            commentValue={t(`${localePath}.comment`)}
            value={t(`${localePath}.heading`)}
            displayMultipleSelectInformation={displayMultipleSelectInformation}
            textMultipleSelect={t('share.textMultipleSelect')}
          />
          <WrappedComponent getValidationProps={this.getValidationProps} {...this.props} />
        </ContentWrapper>
      );
    }
  }

  WithSingleFieldValidation.contextTypes = {
    t: PropTypes.func,
  };

  WithSingleFieldValidation.propTypes = {
    name: PropTypes.string,
    values: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.object,
    ]),
    onChange: PropTypes.func,
    errors: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.object,
    ]),
    isValid: PropTypes.bool,
    localePath: PropTypes.string,
    onClick: PropTypes.func,
    buttonText: PropTypes.string,
    displayMultipleSelectInformation: PropTypes.bool,
  };

  WithSingleFieldValidation.defaultProps = {
    name: '',
    values: [],
    onChange: () => {},
    errors: [],
    isValid: false,
    localePath: '',
    onClick: () => {},
    buttonText: '',
    displayMultipleSelectInformation: false,
  };

  return withDynamicButtonCaption(WithSingleFieldValidation);
};


export default withSingleFieldValidation;
